import { styled } from '@thesisedu/web'

export const LoadingContainer = styled.div`
  display: block;
  width: 100%;
  text-align: center;
  margin: ${props => props.theme['@size-l']} auto;
`
